import React, { Component } from 'react';
import { InputGroupAddon, InputGroup, Input, Button } from 'reactstrap';
import { Dropdown } from 'react-bootstrap'; /* reactstrap also has Dropdown component but for some unknown reason it is not working with class-based component. We decided to use another library(which is react-bootstrap) for Dropdown component */

import { BsSearch, BsX } from "react-icons/bs";

import { RecentCompletedJobs } from '../components/RecentCompletedJobs';
import { GetFilteredData } from '../Service';
import { FilteredResults } from './FilteredResults';

// enum SearchModeEnum {
//     Reference1 = 1;
//     Reference2 = 2;
//     ConsignmentNumber = 3;
//     Barcode = 4;
//     Ref1Ref2ConsignmentNumber = 5;
// }


export class TogglePanel extends Component {
    static displayName = TogglePanel.name;

    constructor(props) {
        super(props);
        this.state = {
            searchInput: '',
            searching: false,
            filterInitialised: false,
            searchMode: 5, /* Either "Ref1Ref2ConsignmentNumber(5)" or "Barcode(4)" */
        };

    }


    get searchModePlaceholder() {
        if(this.state?.searchMode === 5) {
            return 'Search by Consignment or Reference...';
        } else if(this.state?.searchMode === 4) {
            return 'Search by Barcode...'
        } else {
            return '';
        }
    }


    get searchModeDropdownText() {
        if(this.state?.searchMode === 5) {
            return 'Quick Search';
        } else if(this.state?.searchMode === 4) {
            return 'Barcode'
        } else {
            return '';
        }
    }
    

    // Search Button (Also search final trigger)
    handleSearchSubmit = (event) => {
        if (this.state.searchInput.length < 4) {
            alert("Please use a longer search criteria");
            return;
        }

        this.setState({
            filterInitialised: true,
            searching: true
        });    
    };


    // Keystroke monitor
    handleSearchKeydown = (event) => {
        var charCode;

        if (event && event.which) {
            charCode = event.which;
        } else if (window.event) {
            event = window.event;
            charCode = event.keyCode;
        }

        if (charCode === 13) {
            this.handleSearchSubmit();
        }
    };

    // Text Change monitor
    handleSearchChange = (event) => {
        this.setState({
            searchInput: event.target.value,
            filterInitialised: false
        });
    }

    // Clear button
    handleSearchClear = (event) => {
        this.setState({
            searchInput: '',
            filterInitialised: false
        });
    }

    updateSearching = (event) => {
        if (event.target.innerText === 'Search Results') {
            if (this.state.searchInput.length >= 4) {
                this.setState({ searching: true });
            }
        } else if (event.target.innerText === 'Recent Completed Jobs') {
            this.setState({ searching: false, filterInitialised: false });
        }
    };


    render() {
        const mainContent = this.state.searching && this.state.filterInitialised
            ? <FilteredResults searchString={this.state.searchInput} searchBy={this.state.searchMode}></FilteredResults>
            : <RecentCompletedJobs></RecentCompletedJobs>;
        
        return <div className="flex flex-column gap-3">
            <InputGroup size="sm">
                <InputGroupAddon addonType="prepend">
                    <Dropdown>
                        <Dropdown.Toggle variant="primary">{this.searchModeDropdownText}</Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => this.setState({ searchMode: 5 })}>Quick Search</Dropdown.Item>
                            <Dropdown.Item onClick={() => this.setState({ searchMode: 4 })}>Barcode</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </InputGroupAddon>
                <Input placeholder={this.searchModePlaceholder} value={this.state.searchInput} onKeyPress={this.handleSearchKeydown} onChange={this.handleSearchChange} style={{ height: 'unset' }} />
                <InputGroupAddon addonType="append">
                    <Button color="primary" onClick={this.handleSearchSubmit}><BsSearch /></Button>
                </InputGroupAddon>
                <InputGroupAddon addonType="append">
                    <Button color="danger" onClick={this.handleSearchClear}><BsX /></Button>
                </InputGroupAddon>
            </InputGroup>

            <div className="modes-indicator flex flex-row" style={{ height: '40px' }}>
                <b className={"btn btn-block " + (!this.state.filterInitialised ? 'btn-primary' : 'btn-light')} onClick={this.updateSearching}>Recent Completed Jobs</b>
                <b className={"btn btn-block " + (this.state.filterInitialised ? 'btn-primary' : 'btn-light disabled')} style={{ marginTop: '0px' }} onClick={this.updateSearching}>Search Result</b>
            </div>

            {mainContent}
        </div>
    }
}